import {
    CircularProgress,
    Fab,
    Icon,
    Menu,
    MenuItem,
    Snackbar,
    Typography,
} from "@material-ui/core";
import { useEffect, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useToolbarOptions } from "../context/toolbarOptions";
import * as TraktApi from "../api/trakt";
import Poster from "../components/Poster";
import Backdrop from "../components/Backdrop";
import SharedListSelectionDialog from "./SharedListSelectionDialog";
import "./MovieScreen.css";

const styles = {
    container: {
        height: "100%",
    },
    loading: {
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
    },
};

const MARGIN = "20px";
const SHARED_LIST_DIALOG_OPEN_PARAM = "sharedListsDialogOpen";

const MovieScreen = () => {
    const { slug } = useParams();
    const { search } = useLocation();

    const query = new URLSearchParams(search);

    const [isSharedListDialogOpen, setSharedListDialogOpen] = useState(
        query.get(SHARED_LIST_DIALOG_OPEN_PARAM) === "true"
    );

    const [movie, setMovie] = useState(null);
    const { setToolbarOptions } = useToolbarOptions();

    useEffect(() => {
        const loadMovie = async () => {
            try {
                setMovie(await TraktApi.getMovieBySlug(slug));
            } catch (e) {
                console.log(e);
            }
        };
        loadMovie();
    }, [slug]);

    useEffect(() => {
        if (movie != null) {
            setToolbarOptions({ title: movie.title, items: [] });
        } else {
            setToolbarOptions({ title: "", items: [] });
        }
    }, [movie, setToolbarOptions]);

    return (
        <div style={styles.container}>
            {movie ? (
                <Movie
                    slug={slug}
                    movie={movie}
                    isSharedListDialogOpen={isSharedListDialogOpen}
                    setSharedListDialogOpen={setSharedListDialogOpen}
                />
            ) : (
                <Loading />
            )}
        </div>
    );
};

const Movie = (props) => {
    const {
        slug,
        movie,
        isSharedListDialogOpen,
        setSharedListDialogOpen,
    } = props;

    const [snackbar, setSnackbar] = useState("");

    const history = useHistory();

    const [plusAnchor, setPlusAnchor] = useState(null);
    const handlePlusClick = (event) => {
        setPlusAnchor(event.currentTarget);
    };

    return (
        <>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-evenly",
                }}
            >
                <Backdrop item={movie} />
                <div style={{ position: "absolute" }}>
                    <a
                        href={movie.trailer}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "inherit" }}
                    >
                        <Icon fontSize="large">play_circle_outline</Icon>
                    </a>
                </div>
            </div>
            <div className="movieOverview">
                <div style={{ display: "flex", flexDirection: "row" }}>
                    <Poster item={movie} width={120} height={180} />
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            marginLeft: MARGIN,
                            marginRight: MARGIN,
                        }}
                    >
                        <Typography variant="subtitle1">
                            ⭐ {movie.rating.toFixed(1)}
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            style={{ marginTop: MARGIN }}
                        >
                            📅 {movie.year}
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            style={{ marginTop: MARGIN }}
                        >
                            ⏳ {movie.runtime}
                            {"'"}
                        </Typography>
                    </div>
                </div>
                <Typography variant="h6" style={{ marginTop: MARGIN }}>
                    {movie.title}
                </Typography>
                <Typography
                    variant="body2"
                    style={{ marginTop: MARGIN, textTransform: "capitalize" }}
                >
                    {movie.genres.join(", ")}
                </Typography>
                <Typography variant="body1" style={{ marginTop: MARGIN }}>
                    {movie.overview}
                </Typography>
            </div>
            <div className="movieFab">
                <Fab color="secondary" onClick={handlePlusClick}>
                    <Icon>add</Icon>
                </Fab>
            </div>
            {isSharedListDialogOpen && (
                <SharedListSelectionDialog
                    movie={movie}
                    open={true}
                    onClose={(result) => {
                        if (result) {
                            if (!result.error) {
                                setSnackbar("Applied successfully!");
                            } else {
                                setSnackbar(result.error);
                            }
                        }
                        setSharedListDialogOpen(false);
                        history.replace(`/movies/${slug}`);
                    }}
                />
            )}
            {snackbar !== "" && (
                <Snackbar
                    open={snackbar !== ""}
                    message={snackbar}
                    onClose={() => setSnackbar("")}
                    autoHideDuration={1500}
                />
            )}
            {plusAnchor && (
                <Menu
                    open={plusAnchor !== null}
                    anchorEl={plusAnchor}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right",
                    }}
                    transformOrigin={{ vertical: "top", horizontal: "right" }}
                    onClose={() => setPlusAnchor(null)}
                >
                    <MenuItem
                        onClick={() => {
                            setSharedListDialogOpen(true);
                            history.replace(
                                `/movies/${slug}?${SHARED_LIST_DIALOG_OPEN_PARAM}=true`
                            );
                            setPlusAnchor(null);
                        }}
                        onClose={() => setPlusAnchor(null)}
                    >
                        Add to shared list
                    </MenuItem>
                </Menu>
            )}
        </>
    );
};

const Loading = () => {
    return (
        <div style={styles.loading}>
            <CircularProgress color="secondary" />
        </div>
    );
};

export default MovieScreen;
